import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { UsersService } from "./users.service";
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { ToastrService } from "ngx-toastr";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.sass"],
})
export class UsersComponent implements OnInit {
  closeResult: string;
  page: number = 1;

  itemsPerPage = 5;

  active_Page: number = 0;
  totalItems: any;
  allUsersList: any;

  deleted_page: number = 0;
  totalDeltedItems: any;
  allDeletedUsersList: any;

  searchText: any;
  isDeleted: number = 0 || 1;
  adminId = "";
  userId = "";
  adminFName = "";
  adminLName = "";
  adminAddress = "";
  adminCity = "";
  adminPincode = "";
  adminState = "";
  adminPhone = "";
  adminEmail = "";
  adminUsertype = "";
  adminSource = "";
  adminRefcode = "";
  adminActivationstatus = "";
  adminKyc = "";
  adminTwofactor = "";
  adminIsphoneverfied = "";
  adminRefby = "";
  adminIpaddress = "";
  adminCreated = "";
  searchBy = "";

  newMobileNumber = "";
  isOTPSended = false;
  otp = "";
  constructor(
    private userService: UsersService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.getUsers();
    this.getDeletedUsers();
    // this.toastr.success("hi")
  }

  getUsers() {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: 0,
      isDeleted: 0, // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      // "isDeleted": 2        // 2 for getting all users
    };
    console.log("Main Req", data);
    this.userService.getUsers(data).subscribe((result: any) => {
      console.log("Main Res", result.data);
      if (result.statusCode == 200) {
        this.allUsersList = result.data;
        this.totalItems = result.totalRecords;
        this.spinner.hide();
      } else {
        this.allUsersList = [];
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  gty(active_Page: any) {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: this.active_Page - 1,
      isDeleted: 0, // 0 for not deleted users
      // "isDeleted": 1        // 1 for deleted users
      // "isDeleted": 2        // 2 for getting all users
    };
    console.log("gty Req", data);
    this.userService.getUsers(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        console.log("gty res", result.data);
        this.allUsersList = result.data;
        this.totalItems = result.totalRecords;
        this.spinner.hide();
      } else {
        this.allUsersList = [];
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  getDeletedUsers() {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: 0,
      isDeleted: 1,
    };
    this.userService.getUsers(data).subscribe((result: any) => {
      console.log("deleted users ", result);
      if (result.statusCode == 200) {
        this.allDeletedUsersList = result.data;
        this.totalDeltedItems = result.totalRecords;
        this.spinner.hide();
      } else {
        this.allDeletedUsersList = [];
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  gty_del(deleted_page: any) {
    this.spinner.show();
    let data = {
      perPage: this.itemsPerPage,
      page: this.deleted_page - 1,
      isDeleted: 1,
    };
    this.userService.getUsers(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        console.log("deleted users", result.data);
        this.allDeletedUsersList = result.data;
        this.totalDeltedItems = result.totalRecords;
        this.spinner.hide();
      } else {
        this.allDeletedUsersList = [];
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  search() {
    if (this.searchText != "") {
      let data = {
        fieldName: this.searchBy,
        searchText:
          this.searchBy == "userID" ? Number(this.searchText) : this.searchText,
      };
      this.spinner.show();
      this.userService.searchUser(data).subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.allUsersList = result.data.filter(
            (user) => user.isDeleted === 0
          );
          this.allDeletedUsersList = result.data.filter(
            (user) => user.isDeleted === 1
          );
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
        console.log(result);
      });
    } else {
      this.toastr.error("Please Fill Search text");
    }
  }

  sendOTP() {
    let data = {
      userID: this.userId,
      mobileNumber: this.newMobileNumber,
    };
    console.log(data);
    this.spinner.show();
    this.userService.sendOneTimePassword(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.isOTPSended = true;
        this.toastr.success("OTP Send to " + this.newMobileNumber);
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
        this.isOTPSended = false;
      }
    });
  }

  verifyOTP() {
    let data = {
      mobileNumber: this.newMobileNumber,
      otp: Number(this.otp),
    };
    console.log(data);
    this.spinner.show();
    this.userService.verifyOneTimePassword(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success(result.message);
        this.adminPhone = this.newMobileNumber;
        this.newMobileNumber = "";
        this.otp = "";
        this.mobileModalReference.close();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  // applyFilter(filterValue:any){
  //   console.log(filterValue);
  //   let filterValueLower = filterValue.toLowerCase();
  //        if(filterValue === '' ) {
  //            this.allUsersList=this.allUsersList_forFilter;
  //        }
  //        else {
  //          this.allUsersList = this.allUsersList_forFilter.filter((employee:any) => employee.firstName.toLowerCase().includes(filterValueLower))
  //        }
  // }

  exportToExcel() {
    /* pass here the table id */
    let element = document.getElementById("excel-table");
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, "Users Report.xlsx");
  }

  allUsers: any;
  getAllUsers(perPage: any, deleteStatus: Number) {
    this.spinner.show();
    let data = {
      perPage: perPage,
      page: 0,
      isDeleted: deleteStatus,
    };
    // console.log(data)
    this.userService.getUsers(data).subscribe((result: any) => {
      console.log("all users data", result);
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.allUsers = result.data;
        console.log(this.allUsers);
        this.exportAllToExcel(this.allUsers);
      } else {
        this.allUsers = [];
      }
    });
  }
  exportAllToExcel(array: any[]) {
    // Check if the array is for deleted drivers
    const isDeleted = array.length > 0 && array[0].isDeleted === 1;

    const data = array.map((item) => {
      const createdOnTS = item.createdOnTS * 1000; // Ensure it's in milliseconds
      const formattedDate = new Date(createdOnTS).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      return {
        Name: item.firstName + " " + item.lastName,
        Mobile: item.phoneNumber,
        Email: item.emailId,
        City: item.city,
        Requirement: item.requirements,
        RegistrationDate: formattedDate,
      };
    });

    // Determine file name based on whether drivers are deleted or not
    const fileName = isDeleted ? "Deleted_Users.xlsx" : "Active_Users.xlsx";

    // Export to Excel
    if (data.length > 0) {
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, fileName);
    } else {
      console.log(
        isDeleted ? "No deleted users found." : "No non-deleted users found."
      );
    }
  }

  editUser(content1: any, data: any) {
    this.openModal(content1);
    this.adminId = data._id;
    this.userId = data.userID;
    this.adminFName = data.firstName;
    this.adminLName = data.lastName;
    this.adminAddress = data.address;
    this.adminCity = data.city;
    this.adminPincode = data.pincode;
    this.adminState = data.state;
    this.adminPhone = data.phoneNumber;
    this.adminEmail = data.emailId;
    this.adminUsertype = data.userType;
    this.adminSource = data.source;
    this.adminRefcode = data.refCode;
    this.adminActivationstatus = data.activationStatus;
    this.adminKyc = data.kyc;
    this.adminTwofactor = data.two_factor;
    this.adminIsphoneverfied = data.isPhoneVerified;
    this.adminRefby = data.refBy == null ? "null" : data.refBy;
    this.adminIpaddress = data.ipAddress;
    this.adminCreated = data.createdOn;
    this.isDeleted = data.isDeleted;
  }

  mobileModalReference: NgbModalRef;
  openMobileModal(content2, data: any) {
    this.mobileModalReference = this.modalService.open(content2);
    this.mobileModalReference.result.then(
      (result) => {
        // this.modalService.open(content2).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  // update User Info
  updateAdmin() {
    let data = {
      id: this.adminId,
      userID: this.userId,
      firstName: this.adminFName,
      lastName: this.adminLName,
      address: this.adminAddress,
      city: this.adminCity,
      pincode: this.adminPincode,
      state: this.adminState,
      phoneNumber: this.adminPhone,
      userType: this.adminUsertype,
      emailId: this.adminEmail,
      source: this.adminSource,
      refCode: this.adminRefcode,
      activationStatus: this.adminActivationstatus,
      kyc: this.adminKyc,
      two_factor: this.adminTwofactor,
      isPhoneVerified: this.adminIsphoneverfied,
      refBy: this.adminRefby,
      isDeleted: this.isDeleted,
    };
    console.log(data);
    this.spinner.show();
    this.userService.updateUser(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success(result.message);
        this.getUsers();
        this.modalService.dismissAll();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  deleteUser(data: any) {
    this.spinner.show();
    let sendData = {
      id: data._id,
      isDeleted: 1,
    };
    this.userService.updateUser(sendData).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.spinner.hide();
        this.toastr.success("User Deleted Successfully");
        this.getUsers();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  openModal(content) {
    this.modalService.open(content, { size: "lg" }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  routeViewDetails(data) {
    this.router.navigate(["dashboard/viewUserDetails"], {
      queryParams: { id: data._id },
    });
  }

  routeWalletDetails(data: any) {
    this.router.navigate(["dashboard/user/wallet"], {
      queryParams: { id: data._id },
    });
  }
}
